import config from "../config/config";
import { userService } from "../services";

export const ImageUpload = {
  fetchImageUpload,
  fetchImageUpload2,
};

async function fetchImageUpload(payload) {
  try {
    let apiEndpoint = `${config.apiName.fileUpload}`;
    let response = await userService.file(apiEndpoint, payload);
    console.log("yashfetchImageUpload", response);
    if (response && response.status === 200) {
      return response?.data;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchImageUpload2(payload) {
  try {
    let apiEndpoint = `${config.apiName.fileUpload2}`;
    let response = await userService.file(apiEndpoint, payload);

    console.log("yashresp", response);
    if (response && response.status === 200) {
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
